import Tags from '../Tags';
import { IconKeys } from '../Icon/IconKeys';
import useElapsedTime from './useElapsedTime';

function ClockCounter({ lastTime }: any): JSX.Element {
  const ongoingTime = useElapsedTime(lastTime);

  return (
    <Tags.LabeledIcon
      label={ongoingTime}
      icon={IconKeys.TIME}
    />
  );
}

export default ClockCounter;
